import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

const deep = { deep: true }

export const StudyProgramsRedux = createActions(
  {},
  {
    prefix: 'STUDY_PROGRAMS_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = StudyProgramsRedux
export const StudyProgramsTypes = Types
export default Creators

export const INITIAL_STATE = createState({}, {
  get: true,
})

export const reducer = createReducer(
  INITIAL_STATE, {},
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/StudyProgramsRedux.js